import makeStyles from '@mui/styles/makeStyles';

// ui-library body portals are `z-50` and would paint under this host's 200 wrapper (the library's own
// z-40 rail / z-50 overlay tiering only helps below 50). Own hook so the rule exists only with the new sidebar.
const useNewSidebarPortalStyles = makeStyles({
  '@global': {
    'body > [data-tailwind].z-50': {
      zIndex: 200,
    },
  },
});

const NewSidebarPortalStyles = () => {
  useNewSidebarPortalStyles();
  return null;
};

export default NewSidebarPortalStyles;
